import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ExecutiveBody from "@/pages/ExecutiveBody";
import Gallery from "@/pages/Gallery";
import Notices from "@/pages/Notices";
import Members from "@/pages/Members";
import Payment from "@/pages/Payment";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ManageNotices from "@/pages/admin/ManageNotices";
import ManageGallery from "@/pages/admin/ManageGallery";
import ManageExecutives from "@/pages/admin/ManageExecutives";
import ManageMembers from "@/pages/admin/ManageMembers";
import ManageSettings from "@/pages/admin/ManageSettings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/executive-body" element={<ExecutiveBody />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/notices" element={<Notices />} />
              <Route path="/members" element={<Members />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="notices" element={<ManageNotices />} />
              <Route path="gallery" element={<ManageGallery />} />
              <Route path="executives" element={<ManageExecutives />} />
              <Route path="members" element={<ManageMembers />} />
              <Route path="settings" element={<ManageSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
